var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnectedComputersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 11.6667L12.1667 14.8333M1.875 15.625L3.85417 13.6458M14.1458 3.35417L16.125 1.375M7.41667 7.70833L5.83333 9.29167M9.79167 10.0833L8.20833 11.6667M12.1667 11.6667L15.3333 14.8333M5.04167 8.5L9 12.4583L7.8125 13.6458C7.55415 13.9127 7.24528 14.1255 6.90387 14.2718C6.56246 14.4181 6.19535 14.495 5.82392 14.498C5.45249 14.5011 5.08418 14.4301 4.74044 14.2894C4.39671 14.1486 4.08441 13.9409 3.82177 13.6782C3.55912 13.4156 3.35137 13.1033 3.21062 12.7596C3.06987 12.4158 2.99894 12.0475 3.00195 11.6761C3.00497 11.3047 3.08187 10.9375 3.22819 10.5961C3.3745 10.2547 3.58729 9.94585 3.85417 9.6875L5.04167 8.5ZM12.9583 8.5L9 4.54167L10.1875 3.35417C10.4458 3.08729 10.7547 2.8745 11.0961 2.72819C11.4375 2.58187 11.8047 2.50497 12.1761 2.50195C12.5475 2.49894 12.9158 2.56987 13.2596 2.71062C13.6033 2.85137 13.9156 3.05912 14.1782 3.32177C14.4409 3.58441 14.6486 3.89671 14.7894 4.24044C14.9301 4.58418 15.0011 4.95249 14.998 5.32392C14.995 5.69535 14.9181 6.06246 14.7718 6.40387C14.6255 6.74528 14.4127 7.05415 14.1458 7.3125L12.9583 8.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectedComputersIcon);
export default __webpack_public_path__ + "static/media/disconnectedComputersIcon.3631b2248037832b7cfee3bed68b3e52.svg";
export { ForwardRef as ReactComponent };